import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { createRefPath } from 'global/firestoreData/appData/appRefPaths';
import { useContext, useEffect, useState } from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { DemoContext } from '../../cnr/contexts/DemoContext';
import { GoogleSheetsContext } from '../../cnr/contexts/GoogleSheetsContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import AppForm from '../../components/forms/appForms/AppForm';
import TreeViewer from '../../components/viewers/TreeViewer';
import { gEnums } from '../../enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import { settingsHelpers } from '../helpers/settingsHelpers';
import { propDataOpts } from '../settingsProps/settingsAll';
import { useNavigate } from 'react-router-dom';
import { useGoogleSheets } from 'global/cnr/contexts/useHelpers/useGoogleSheets';

export const DemoEvent = () => {

  const navigate = useNavigate();

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews, queryValues } = paps_state ?? {}
  const { gsk } = queryValues ?? {}
  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}

  // const gsk = '1_8PjaQBl2JCtMPwUtE_BIKIiJkr_M-ofM4xbCwy90xw'

  const _pathViews = {
    clients: '6aVuIW8EMdXDysJ8JGt5', // demo
    events: pathViews.demo
  }

  const { getDataFromGoogleSheets } = useGoogleSheets()

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state, googleSheets_handlers } = googleSheetsContext ?? {}
  const { googleSheetsPreview, googleSheetsId, database_fns } = googleSheets_state ?? {}

  // demoContext
  const demoContext = useContext(DemoContext)
  const { demo_state, demo_handlers } = demoContext ?? {}
  const { demoOn, demoPreview, currentName, showPreview, updating } = demo_state ?? {}

  const [currentDemos, setCurrentDemos] = useState({})
  const [selectedDemo, setSelectedDemo] = useState()
  const [formData, setFormData] = useState({ googleSheetKey: gsk })

  const { googleSheetKey } = formData ?? {}

  useEffect(() => {
    if (demoOn) {
      navigate('/clients/' + _pathViews.clients + '/events/1234')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [demoOn]);

  useEffect(() => {
    if (isSuperAdmin) {
      const cb = (x) => {
        setCurrentDemos(x)
      }
      const refPath = createRefPath(['_demos'])
      database_fns.get_data({ refPath, callback: cb })
      // database_fns.set_doc(refPath, dataToUpdate, true, cb)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperAdmin]);


  useEffect(() => {
    if (gsk) {
      demo_handlers.handleStartUpdate()
      getDataFromGoogleSheets({ gsid: gsk, fromCreate: true, forDemo: true, callback: googleSheets_handlers.handleResponse_googleSheet })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gsk]);

  useEffect(() => {
    if (googleSheetsPreview) {
      demo_handlers.handleInit_demo(googleSheetsPreview)
      demo_handlers.handleStopUpdate()
      if (gsk) {
        handle_showDemo()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleSheetsPreview]);

  const handle_getGoogleSheet = () => {
    demo_handlers.handleStartUpdate()
    getDataFromGoogleSheets({
      gsid: googleSheetKey,
      fromCreate: true,
      forDemo: true,
      callback: googleSheets_handlers.handleResponse_googleSheet
    })
  }

  const handle_parentData = (d) => setFormData(d)
  const handle_showDemo = () => demo_handlers.handleSet_demoOn(true)
  const handle_showPreview = (d) => demo_handlers.handleSet_showPreview(!showPreview)

  const handle_saveDemo = () => {
    const cb = (x) => {
      console.log('x', x)
    }
    // const refPath = createRefPath(['_demos', database_fns.get_docKey()])
    const refPath = createRefPath(['clients', 'gsDemos', 'events', database_fns.get_docKey()])
    const dataToUpdate = {
      googleSheetsId,
      name: currentName
    }
    database_fns.set_doc(refPath, dataToUpdate, true, cb)
  }

  const handle_selectedDemo = (a, b) => {
    const { value } = b
    const _currentDemo = currentDemos[value]
    setSelectedDemo(_currentDemo)
    setFormData({ googleSheetKey: _currentDemo.googleSheetsId })
  }

  const optionsList = () => {
    const opts = []
    _.forEach(currentDemos, (demo, demoKey) => {
      opts.push({ key: demoKey, value: demoKey, text: demo.projectName })
    })
    return opts
  }

  const appFormItems = {
    googleSheetKey: settingsHelpers.newPropObject('googleSheetKey', propDataOpts(true, gEnums.formItemTypes.text, null, { urlSheetsLink: 'https://docs.google.com/spreadsheets/d/' })),
  }

  const handleBack = () => {
    navigate(-1)
  }

  const form_google = () => <AppForm
    appFormItems={appFormItems}
    handleSave={handle_getGoogleSheet}
    data_parent={formData}
    handleUpdateParentData={handle_parentData}
    handleSaveCaption="Get Google Sheet"
    css={{ content: 'padd10' }}
  />

  const footer_preview = () => {
    const btns = []
    btns.push({ oc: handle_showDemo, caption: 'Goto Preview', icon: 'arrow right' })
    btns.push({ oc: handle_saveDemo, caption: 'Save Preview', icon: 'save', color: 'green' })
    btns.push({ oc: handle_showPreview, caption: 'Cancel', icon: 'delete', fl: true, color: 'grey' })
    return <UiSaveButtons others={btns} />
  }

  const dropdown = () => <div style={{ padding: '1em' }}>
    <Dropdown
      label={'Demos'}
      fluid
      scrolling
      selection
      options={optionsList()}
      onChange={handle_selectedDemo} />
  </div>

  const wrapper_preview = () => <Wrapper
    header={currentName || 'Test'}
    content={<TreeViewer data={demoPreview} scNames={true} subNames={true} />}
    footer={footer_preview()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    css={{ container: 'app-dark-mode' }}
  />

  const wrapper = () => <Wrapper
    header={<div><Icon name='delete' onClick={handleBack} /> Demo</div>}
    content={form_google()}
    search={isSuperAdmin && dropdown()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    updating={updating}
    css={{ container: 'app-dark-mode' }}
  />

  const content = () => {
    if (showPreview) {
      return wrapper_preview()
    } else {
      return wrapper()
    }
  }

  return content()
}
